export default __webpack_public_path__ + "static/logo-freshcells-systems-engineering-635fbde7c635abdef0de4a086d164c74.svg";